import api from './api';
import type { Project, ProjectDetail, TimeEntry, Invoice } from './erpTypes';

export const PROJEKT_STATUS_LABEL: Record<string, string> = {
  planned: 'Geplant',
  active: 'Aktiv',
  paused: 'Pausiert',
  done: 'Abgeschlossen',
  cancelled: 'Abgebrochen',
};

export const ABRECHNUNGSART_LABEL: Record<string, string> = {
  zeit: 'Nach Aufwand',
  festpreis: 'Festpreis',
};

/** Ob die Tagesabrechnung (ADR 0014) Zeiten von sich aus in einen Rechnungsentwurf ueberfuehrt. */
export const ABRECHNUNGSRHYTHMUS_LABEL: Record<string, string> = {
  manuell: 'Manuell abrechnen',
  taeglich: 'Täglich (Tagesabrechnung)',
  monatlich: 'Monatlich (Tagesabrechnung am 1.)',
};

export type ProjektDaten = Partial<Pick<Project,
  'name' | 'companyId' | 'dealId' | 'budgetCents' | 'stundensatzCents' | 'abrechnungsart' | 'abrechnungsrhythmus' | 'startAt' | 'endAt' | 'description'>>;

const projektService = {
  async list(filter?: { status?: string; companyId?: string }): Promise<Project[]> {
    const response = await api.get('/projekte', { params: filter || {} });
    return response.data;
  },
  async get(id: string): Promise<ProjectDetail> {
    const response = await api.get(`/projekte/${id}`);
    return response.data;
  },
  async create(daten: ProjektDaten & { name: string }): Promise<Project> {
    const response = await api.post('/projekte', daten);
    return response.data;
  },
  async update(id: string, daten: ProjektDaten): Promise<Project> {
    const response = await api.patch(`/projekte/${id}`, daten);
    return response.data;
  },
  async setStatus(id: string, status: string): Promise<Project> {
    const response = await api.post(`/projekte/${id}/status`, { status });
    return response.data;
  },
  async zeiten(id: string): Promise<TimeEntry[]> {
    const response = await api.get(`/projekte/${id}/zeiten`);
    return response.data;
  },
  /** Erzeugt den Rechnungsentwurf aus den unabgerechneten Zeiten. */
  async abrechnen(id: string, daten: { bis?: string; nurAbrechenbar?: boolean; zusammenfassen?: boolean }): Promise<Invoice> {
    const response = await api.post(`/projekte/${id}/abrechnen`, daten);
    return response.data;
  },
};

export default projektService;
